import { WALKMINING_WEB_API_HOST } from '../../../config'

export default class WalkMiningWebApi {
  static async get(path: string, isSSR: boolean) {
    try {
      const response = await fetch((isSSR ? WALKMINING_WEB_API_HOST : '/api/v1/') + path)
      if (response.ok) {
        const responseJson = await response.json()
        return responseJson ? responseJson : null
      }
    } catch (err: any) {
      console.log(`Error fetching from WalkMining Web API ${path}: ${err}`)
    }
    return null
  }

  static async validateInviteCode(isSSR: boolean, code: string): Promise<boolean | null> {
    return WalkMiningWebApi.get(`valid/invite-code/${code}`, isSSR)
  }

  static async getTotalSteps(isSSR: boolean): Promise<any | null> {
    return WalkMiningWebApi.get(`explorer/statistic/total-steps`, isSSR)
  }

  static async getNotices(language: string, isSSR: boolean): Promise<any | null> {
    return WalkMiningWebApi.get(`web/app-service/notice?language=${language}`, isSSR)
  }

  static async getNotice(id: string, language: string, isSSR: boolean): Promise<any | null> {
    return WalkMiningWebApi.get(`web/app-service/notice/${id}?language=${language}`, isSSR)
  }

  static async getExternalLink(externalId: string, language: string, isSSR: boolean): Promise<any | null> {
    return WalkMiningWebApi.get(`web/app-service/link/${externalId}?language=${language}`, isSSR)
  }
}
